module.exports = __webpack_public_path__ + "img/r4dm_hero_2024.1ab3aa5d.png";